import { useQuery } from 'react-apollo';

import { AlbumFolderTags } from '../../../../../../../../graphql/queries/album-folder-tags';
import { getTagsByType } from '../../../../../../../../util/album-folder-tags';
import { ALBUM_FOLDER_TAG_TYPE } from '../../../../../../../../constants/album-folder-tags';
import {
  albumFolderRequiresTagsToOnboard,
  getEligibleTagsByIdentityGender,
  isUniformAlbumFolderTagConfigurable,
} from '../../../helpers';

const sportsCheckSkipTags = ['pageant'];

const useTagsForSportsCheckSkip = ({ albumFolderId, identity }) => {
  const { data: { albumFolder } = {}, loading: loadingTags } = useQuery(
    AlbumFolderTags,
    {
      variables: {
        id: albumFolderId,
      },
    },
  );

  const tags = getTagsByType(
    ALBUM_FOLDER_TAG_TYPE.UNIFORM,
    albumFolder?.tags?.records,
  ).filter(isUniformAlbumFolderTagConfigurable);

  const eligibleTags = getEligibleTagsByIdentityGender(
    tags,
    identity?.gender,
    !albumFolderRequiresTagsToOnboard(albumFolder),
  );

  const isSingleTagOnboarding = eligibleTags.length === 1;

  return {
    tags,
    loadingTags,
    shouldSkipSportsCheck:
      isSingleTagOnboarding &&
      !!sportsCheckSkipTags.includes(
        (eligibleTags?.[0]?.name ?? '').toLowerCase(),
      ),
  };
};

export default useTagsForSportsCheckSkip;
